import type { ResourceBlock } from '@root/@types/base';
import { upliftVariation } from '@root/helpers/variations';
import { isEmpty } from 'lodash-es';

import { isBlockOrInlineAttachment } from './is-block-or-inline-attachment';

export const isBlockContentEmpty = <T extends Pick<ResourceBlock, 'selectedVariationId' | 'variations' | 'content'>>(
  block: T | undefined,
) => {
  if (!block) {
    return true;
  }

  if (isBlockOrInlineAttachment(block) === 'attachment') {
    return false;
  }

  const parsedValues = upliftVariation(block, block.selectedVariationId);
  const { content } = parsedValues;

  return isEmpty(content) || content === '<p></p>';
};
